import styled, { css } from 'react-emotion'
import { Box, spacer, shadow, color } from 'stylist'
import { withProps } from 'recompose'

const disabledStyle = ({ disabled, theme }) =>
  disabled &&
  css`
    background: ${color('offWhite', { theme })};
    color: ${color('cadet', { theme })};
  `

const hoverStyle = ({ hover, theme }) =>
  hover &&
  css`
    &:hover {
      ${shadow('close', { theme })};
    }
  `

const Item = styled(Box.Item)`
  display: grid;
  align-items: center;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  grid-gap: ${spacer(4)};

  > :first-child {
    justify-self: left;
  }

  > :not(:first-child):not(:last-child) {
    justify-self: center;
  }

  > :last-child {
    justify-self: right;
  }

  > :only-child {
    justify-self: unset;
  }

  ${hoverStyle};
  ${disabledStyle};
`

export default withProps({ pad: true })(Item)



// WEBPACK FOOTER //
// ./src/components/ListBox/Item.js